import { parseAsString, useQueryState } from 'nuqs';
import type { ReactElement } from 'react';
import { dpConfig } from 'src/config';
import { Novelties } from 'src/features/novelties/Novelties';
import { useDebounce } from 'use-debounce';

export function NoveltiesContainer(): ReactElement {
  const [search, setSearch] = useQueryState(
    'search',
    parseAsString.withDefault(''),
  );
  const [debouncedSearch] = useDebounce(search, dpConfig.debounce.search);

  return (
    <Novelties
      localSearch={search}
      search={debouncedSearch}
      setSearch={setSearch}
    />
  );
}
